const randomScalingFactor = function() {
    return Math.round(Math.random() * 100);
};
const randomColorFactor = function() {
    return Math.round(Math.random() * 255);
};
const randomColor = function(opacity) {
    return 'rgba(' + randomColorFactor() + ',' + randomColorFactor() + ',' + randomColorFactor() + ',' + (opacity || '.3') + ')';
};

export default randomColor;